import {
  getAnalyticsData, getAnalyticsMetaData,
  getSummaryData, getTrafficConsentTableData
} from '../services/analytics';
import { useQueryWrapper } from './common';
import { iSummaryPayload, iAnalyticsPayload } from '../../interfaces/analytics_v1';

// @flow

const ANALYTICS_META_DATA = 'analyticsMetaData';
const ANALYTICS_SUMMARY_DATA = 'analyticsSummaryData';
const ANALYTICS_DATA = 'analyticsData';
const TRAFFIC_CONSENT_TABLE_DATA = 'trafficConsentTableData';

export const useAnalyticsMetaData = () => useQueryWrapper([ANALYTICS_META_DATA], getAnalyticsMetaData, {
  onError: (errors) => {
    console.log('Error ', errors);
  }
});

export const useSummaryData = (queryPayload: iSummaryPayload) => useQueryWrapper(
  [ANALYTICS_SUMMARY_DATA, queryPayload], getSummaryData, {
    enabled: queryPayload.metricFields.length > 0,
    onError: (errors) => {
      console.log('Error ', errors);
    }
  }
);

export const useAnalyticsData = (queryPayload: iAnalyticsPayload) => useQueryWrapper(
  [ANALYTICS_DATA, queryPayload], getAnalyticsData, {
    onError: (errors) => {
      console.log('Error ', errors);
    }
  }
);

export const useTrafficConsentTableData = (queryPayload: iTableDataPayload) => useQueryWrapper(
  [TRAFFIC_CONSENT_TABLE_DATA, queryPayload], getTrafficConsentTableData, {
    enabled: queryPayload.enabled,
    onError: (errors) => {
      console.log('Error ', errors);
    }
  }
);
